module.exports = __webpack_public_path__ + "img/area-limit-btn.a3fb694e.png";